import config from '../client/config';
import usePost from './usePost';
import { Slug } from '../utils/abTests';
import { useCallback } from 'react';

function useAbMarkSuccess(slug: Slug, successType: string) {
  const url = `${config.abApiUrl}/abtests/${slug}/markSuccessful`;
  const [post] = usePost(url);

  const markSuccess = useCallback(() => {
    post({
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ SuccessType: successType }),
    });
  }, [post, successType]);

  return {
    markSuccess,
  };
}

export default useAbMarkSuccess;
